import { FirestoreDataConverter, Timestamp } from 'firebase/firestore';
import { Entity } from './entity';

export interface DailyStatistics extends Entity {
  date: Date;
  totalUsers: number;
  activeUsers: number;
  activeHabits: number;
  activePartnerships: number;
  recordsCreated: number;
  readingsCompleted: number;
}

export interface FirestoreDailyStatistics extends Omit<DailyStatistics, 'date'> {
  date: Timestamp;
}

export const DailyStatisticsConverter: FirestoreDataConverter<DailyStatistics, FirestoreDailyStatistics> = {
  toFirestore: (stats: DailyStatistics): FirestoreDailyStatistics => {
    return {
      ...stats,
      date: Timestamp.fromDate(stats.date),
    };
  },
  fromFirestore: (snapshot, options): DailyStatistics => {
    const stats = snapshot.data(options) as FirestoreDailyStatistics;
    return {
      ...stats,
      date: stats.date.toDate(),
    };
  },
};

export const StatisticsCollection = 'statistics';
